var OCS = OCS || {};
OCS.BootFunctions = OCS.BootFunctions || {};
OCS.BootFunctions.mobile = OCS.BootFunctions.mobile || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.Panel = new Class({
    Implements: [Options, Events, new Class(OCS.Interfaces.UniqueId)],
    viewer: null,
    popup: null,
    viewer_options: {},
    update_interval: null,
    product: null,
    bound_methods: {},
    options: {
        container: null,
        container_selector: "",
        entry_id: null,
        panel_class_name: 'panel',
        map_container_prefix: 'map_',
        panel_container_prefix: 'panel_',
        panel_manager_el: '#panel_container',
        update_url_event_string: 'update_url_event',
        update_interval_rate: 900000,
        product_meta_info: {}
    },
    initialize: function (op) {
        this.bound_methods.update_url_state = this.update_url_state.bind(this);
        var current_panel = document.id(op.container).retrieve('panel');
        if (current_panel) {
            return current_panel;
        }
        this.setOptions(this.options, op);
        if (this.options.container_selector) {
            this.set_container(this.options.container_selector);
        }

        if (!this.update_interval && this.options.update_interval_rate) {
            this.update_interval = setInterval(this.update_product.bind(this), this.options.update_interval_rate);
        }
        this.options.container.store('panel', this);
    },
    load_panel_options: function () {
        var tm = OCS.WxBriefing.Functions.get_template_manager();
        var panel_options = tm.get_html('panel_options_base', {});
        jQuery(this.options.$container).append(panel_options);
        this.size_panel_options();

    },
    size_panel_options: function () {
        var map_height = jQuery(this.options.$container).outerHeight();
        var map_options_height = jQuery('.title', this.options.$container).outerHeight();
        var map_controls_container_height = 42;
        var legend_info_container_height = 40;
        var legend_container_height = 10;
        var offset = 3;

        var options_max_height = map_height - map_options_height - map_controls_container_height - legend_info_container_height - legend_container_height - offset;
        jQuery(this.options.$container).find('.panel_options_container > .options').css('max-height', options_max_height + 'px');
    },
    populate_panel: function () {
        var pm = OCS.WxBriefing.Functions.get_product_manager();
        var panel_ops = {
            entry_id: this.product.options.entry_id,
            map_container_number: this.options.container_selector.replace(this.options.panel_container_prefix, '')
        };
        if (OCS.WxBriefing.Live.UI.get_debug() || true) {
//            panel_ops.product_type = pm.get_product_type(this.product.options.entry_id);
        }
//        var tm = OCS.WxBriefing.Functions.get_template_manager();
//        var panel_contents = tm.get_html('panel_contents', panel_ops);
//        this.options.$container.html(panel_contents);
    },
    unpopulate_panel: function () {
        this.options.container.removeEvents();
        this.options.container.empty();
        this.options.$container.html();
    },
    get_product: function () {
        return this.product;
    },
    set_product: function (prod) {
        this.product = prod;
    },
    get_product_content: function () {
        var product = this.get_product();
        if (product) {
            return product.get_product_content();
        }
    },
    get_product_title: function () {
        var product = this.get_product();
        if (product) {
            return product.get_product_title();
        }
    },
    get_product_entry_id: function () {
        var product = this.get_product();
        if (product) {
            return product.get_entry_id();
        }
    },
    set_container: function (container) {
        if (typeof container === 'string') {
            this.options.container_selector = container;
            var cont = jQuery('#' + this.options.container_selector);
            if (cont.length) {
                this.options.$container = cont;
            }
        } else {
            this.options.$container = container;
        }
    },
    resize: function () {
        this.size_panel_options();
    },
    set_viewer: function (viewer) {
        // Remove the listener for updated url state
        if (!this.popup) {
            if (this.viewer && this.viewer.options.update_url_event_string) {
                this.viewer.removeEvent(this.viewer.options.update_url_event_string, this.bound_methods.update_url_state);
            }

            if (viewer.options.update_url_event_string) {
                viewer.addEvent(viewer.options.update_url_event_string, this.bound_methods.update_url_state);
            }
        }

        this.viewer = viewer;
        var meta_info = this.get_product_meta_info();
        if (meta_info && typeof viewer.update_product_options === 'function') {
            this.viewer.update_product_options(meta_info);
        }
    },
    get_viewer: function () {
        return this.viewer;
    },
    get_panel_obj: function () {
        return this.options.container.getParent().retrieve('panel_obj');
    },
    set_popup: function (popup) {
        this.popup = popup;
    },
    get_product_meta_info: function () {
        return this.options.product_meta_info;
    },
    set_product_meta_info: function (product_meta_info) {
        this.options.product_meta_info = product_meta_info;
    },
    update_url_state: function (ops) {
        if (!this.popup) {
            var state = {};
            state[this.get_panel_obj().get_url_panel_id()] = ops.state;
            OCS.WxBriefing.Functions.get_url_manager().update_url_state(state);
        }
    },
    update_product: function () {

    },
    destroy: function () {
        if (this.update_interval) {
            clearInterval(this.update_interval);
        }
        if (!this.popup && this.viewer && this.viewer.options.update_url_event_string) {
            this.viewer.removeEvent(this.viewer.options.update_url_event_string, this.bound_methods.update_url_state);
        }
        this.unpopulate_panel();
        this.options.container.store('panel', null);
    }

});

OCS.WxBriefing.Classes.PanelMobile = new Class({
    load_panel_options: function () {

    }
});
OCS.BootFunctions.mobile.panel_init = function () {
    OCS.WxBriefing.Classes.Panel.implement(new OCS.WxBriefing.Classes.PanelMobile());
}